import { moduleDefinitionsQueryOptions } from '@/queries/moduleDefinitionsQueryOptions';
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/$module_id/')({
  loader: async ({ context: { queryClient }, params }) => {
    const { module_id } = params;
    const result = await queryClient.ensureQueryData(moduleDefinitionsQueryOptions);

    const currentModule = result?.find((m) => m.id === module_id);

    throw redirect({
      to: '/$module_id/$entity_type_id/segments/$segment_id',
      params: {
        module_id,
        entity_type_id: currentModule?.entityDefinitions?.[0]?.id as string,
        segment_id: 'all'
      },
    })
  },
})
